import { render } from "./showStar.vue?vue&type=template&id=7ce041d9&scoped=true"
import script from "./showStar.vue?vue&type=script&lang=ts"
export * from "./showStar.vue?vue&type=script&lang=ts"

import "./showStar.vue?vue&type=style&index=0&id=7ce041d9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7ce041d9"

export default script